// extracted by css-extract-rspack-plugin
export default {"wrapper":"_ce33e64c","content":"_eb03acd6"};